import { render } from "./FacultyModal.vue?vue&type=template&id=5638b297&scoped=true"
import script from "./FacultyModal.vue?vue&type=script&lang=js"
export * from "./FacultyModal.vue?vue&type=script&lang=js"

import "./FacultyModal.vue?vue&type=style&index=0&id=5638b297&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5638b297"]])

export default __exports__